"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInput = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledInput = styled_components_1.default.input `
  background: ${(props) => props.disabled ? config_1.colors.huron : config_1.colors.white} !important;
  color: ${(props) => props.disabled ? config_1.colors.thundercloud : config_1.colors.black} !important;
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};

  &:focus {
    border-color: ${config_1.colors.blurple};
  }
`;
